export const CompanyRelationDetails = {
    GET_ALLCOMPANYRELATION: "GET_ALLCOMPANYRELATION",
    POST_ALLCOMPANYRELATION: "POST_ALLCOMPANYRELATION",
    UPDATE_ALLCOMPANYRELATION: "UPDATE_ALLCOMPANYRELATION",
    DELETE_COMPANYRELATION: "DELETE_COMPANYRELATION",
    GET_ALLSUBCOMPANIES: "GET_ALLSUBCOMPANIES",
}
